import React, { useId, useState } from "react";
import { SideDrawer, SideDrawerCloseButton } from "@dmc/ui";
import ApiData from "../../api/ApiData";
import useValidationText from "../../hooks/useValidationText";
import useValidationPhone from "../../hooks/useValidationPhone";
import { InputEditVer1 } from "../UI/InputEditVer1";
import { SiteFormField } from "../UI/SiteFormField";
import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

export const Registration = ({ setRegUser }) => {
  const titleId = useId();
  const [password, setPassword] = useState("");
  const [repeatPassword, setrepeatPassword] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [fatherName, setFatherName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");

  const validPhone = useValidationPhone(phone);
  const validFirstName = useValidationText(firstName);
  const validLastName = useValidationText(lastName);
  const validFatherName = useValidationText(fatherName);

  const onSubmit = (e) => {
    e.preventDefault();
    if (
      repeatPassword === "" ||
      password === "" ||
      firstName === "" ||
      lastName === "" ||
      fatherName === "" ||
      email === "" ||
      phone === ""
    ) {
      return alert("Не все поля заполнены");
    }
    if (!email.match(/\w*[@]\w{2,8}[.]\w{2,4}/u)) {
      return alert("Неверный формат email");
    }

    if (password !== repeatPassword) {
      return alert("Пароли не совпадают");
    }
    if (password.length < 6) {
      return alert("Слишком короткий пароль. Минимум 6 символов");
    }

    ApiData.getRegistration(
      password,
      firstName,
      lastName,
      fatherName,
      email.toLocaleLowerCase(),
      phone,
    );
    setRegUser(false);
  };

  const close = () => setRegUser(false);

  return (
    <SideDrawer
      open
      onClose={close}
      title="Регистрация нового сотрудника"
      titleId={titleId}
      usePortal={false}
      toolbar={<SideDrawerCloseButton onClick={close} title="Закрыть" />}
    >
      <form className="site-modal-body" onSubmit={onSubmit}>
        <div className="site-modal-fields company-edit-grid">
          <SiteFormField label="Email (логин)" full>
            <InputEditVer1
              className="site-form-control"
              placeholder="e-mail будет являться логином"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Фамилия">
            <InputEditVer1
              className="site-form-control"
              placeholder="Введите фамилию"
              value={validLastName}
              onChange={(e) => setLastName(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Имя">
            <InputEditVer1
              className="site-form-control"
              placeholder="Введите имя"
              value={validFirstName}
              onChange={(e) => setFirstName(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Отчество">
            <InputEditVer1
              className="site-form-control"
              placeholder="Введите отчество"
              value={validFatherName}
              onChange={(e) => setFatherName(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Телефон">
            <InputEditVer1
              className="site-form-control"
              placeholder="Введите телефон"
              type="number"
              value={validPhone}
              onChange={(e) => setPhone(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Пароль">
            <InputEditVer1
              className="site-form-control"
              placeholder="Придумайте пароль"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </SiteFormField>
          <SiteFormField label="Повторите пароль">
            <InputEditVer1
              className="site-form-control"
              placeholder="Повторите пароль"
              type="password"
              value={repeatPassword}
              onChange={(e) => setrepeatPassword(e.target.value)}
            />
          </SiteFormField>
        </div>
        <footer className="site-modal-footer">
          <BtnOutlineV4 type="button" text="Отмена" onClick={close} />
          <button type="submit" className="btn-primary-v4">
            Зарегистрировать сотрудника
          </button>
        </footer>
      </form>
    </SideDrawer>
  );
};
